<template>
  <div @scroll="throttleScrollHandle" class="question">
    <van-pull-refresh v-model="loading" pulling-text="下拉查看更多" loosing-text="释放加载更多" success-text="加载成功" @refresh="onLoadMore">
      <div class="question-content">
        <!-- <div class="view-box">
        <button v-if="list.length < value.totalCount && auth == 1" @click="view" class="view">查看更多</button>
      </div> -->
        <van-list>
          <ul>
            <li class="msg-item" v-for="item in list" :key="item.index" :id="item.id">
              <div>
                <div class="question-title">
                  <van-image round fit="cover" class="photo" :src="item.memberHeadImg" />
                  <span>{{ item.memberNickname }}</span>
                  <div class="questioner" v-if="item.label">{{ item.label }}</div>
                  <!-- <div class="questioner" v-if="JSON.parse(item.payload.text).label == '问'">问</div>
                  <div class="personal" v-if="JSON.parse(item.payload.text).label == '主播'">主播</div> -->
                  <a>{{ item.publishDate }}</a>
                </div>
                <!-- <div class="circle"></div> -->
                <div class="bubble">
                  <div class="que">
                    <h4 class="title">{{ item.text }}</h4>

                    <!-- <span v-if="item.imgUrlList.length == '1'">
                    <div v-for="item in item.imgUrlList" :key="item.key">
                      <img class="question-img" v-if="item.imgUrl" :src="item.imgUrl" @click="viewImage(item.imgUrlList, value)" alt="" width="100%" />
                    </div>
                  </span> -->
                    <van-grid
                      v-if="item.imgUrlList.length <= 3 && item.imgUrlList.length !== 0"
                      :border="false"
                      :column-num="item.imgUrlList.length"
                      :gutter="3"
                      :center="false"
                    >
                      <van-grid-item v-for="value in item.imgUrlList" :key="value">
                        <van-image :src="value" @click="viewImage(item.imgUrlList, value)" />
                      </van-grid-item>
                    </van-grid>
                    <van-grid v-if="item.imgUrlList.length === 4" :border="false" :column-num="2" :gutter="3" :center="false">
                      <van-grid-item v-for="value in item.imgUrlList" :key="value">
                        <van-image :src="value" @click="viewImage(item.imgUrlList, value)" />
                      </van-grid-item>
                    </van-grid>
                    <van-grid v-if="item.imgUrlList.length > 4" :border="false" :column-num="3" :gutter="3" :center="false">
                      <van-grid-item v-for="value in item.imgUrlList" :key="value">
                        <van-image :src="value" @click="viewImage(item.imgUrlList, value)" />
                      </van-grid-item>
                    </van-grid>
                    <span v-if="item.videoUrlList">
                      <VideoPlayer
                        v-for="value in item.videoUrlList"
                        :key="value"
                        :options="{
                          poster: value + '?vframe/jpg/offset/0',
                          autoplay: false,
                          sources: [
                            {
                              src: value,
                              type: 'video/mp4'
                            }
                          ]
                        }"
                      />
                    </span>
                  </div>
                  <div v-if="item.adminId !== ''" class="answer">
                    <div class="answer-title-box">
                      <img v-if="item && item.adminHeadImg" :src="item.adminHeadImg" class="adminimg" />
                      <span class="name">{{ item.adminName }}</span>
                      <span class="personal">答</span>
                    </div>
                    <h4 class="anstext">{{ item.ansText }}</h4>
                    <van-grid
                      v-if="item.ansImgUrlList.length <= 3 && item.ansImgUrlList.length !== 0"
                      :border="false"
                      :column-num="item.ansImgUrlList.length"
                      :gutter="3"
                      :center="false"
                    >
                      <van-grid-item v-for="value in item.ansImgUrlList" :key="value">
                        <van-image :src="value" @click="viewImage(item.ansImgUrlList, value)" />
                      </van-grid-item>
                    </van-grid>
                    <van-grid v-if="item.ansImgUrlList.length == 4" :border="false" :column-num="2" :gutter="3" :center="false">
                      <van-grid-item v-for="value in item.ansImgUrlList" :key="value">
                        <van-image :src="value" @click="viewImage(item.ansImgUrlList, value)" />
                      </van-grid-item>
                    </van-grid>
                    <van-grid v-if="item.ansImgUrlList.length > 4" :border="false" :column-num="3" :gutter="3" :center="false">
                      <van-grid-item v-for="value in item.ansImgUrlList" :key="value">
                        <van-image :src="value" @click="viewImage(item.ansImgUrlList, value)" />
                      </van-grid-item>
                    </van-grid>
                    <!-- <img v-if="item.ansImgUrl" :src="item.ansImgUrl" alt="" width="100%" max-height="400px" /> -->
                    <div v-if="item.ansVideoUrlList">
                      <VideoPlayer
                        v-for="value in item.ansVideoUrlList"
                        :key="value"
                        :options="{
                          poster: value + '?vframe/jpg/offset/0',
                          autoplay: false,
                          sources: [
                            {
                              src: value,
                              type: 'video/mp4'
                            }
                          ]
                        }"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <ul id="bottom-empty"></ul>
        </van-list>
      </div>
      <div v-if="!enableBottomOut && unreadCount > 0" class="unread-tip">
        <span @click="bottomOutHandle">底部有新消息</span>
      </div>
    </van-pull-refresh>
  </div>
</template>
<script>
import moment from 'moment';
import { throttle } from '@/utils/el';
export default {
  name: 'Question',
  data() {
    return {
      moment,
      list: [],
      emptyList: [],
      pageNo: 1,
      loading: false,
      finished: false,
      auth: $$.module.data.userinfo.auth,
      groupId: $$.module.data.room.questionSettingContent.qsImGroupId,
      refreshing: false,
      api: $$.module.interview.$api,
      value: {},
      chartdata: {
        groupId: this.groupId,
        nextId: '',
        count: 3
      },
      enableBottomOut: true,
      qsFlg: $$.module.data.room.questionSettingContent.qsFlg,
      liveState: $$.module.data.room.roomSettingContent.roomInfo.liveState,
      unreadCount: 0,
      list2: [],
      first: true,
      throttleScrollHandle: throttle(this.scrollHandle, 100)
    };
  },
  mounted() {
    // this.$nextTick(() => {
    // if (this.qsFlg == 1 && this.auth == 1) {
    // this.getlist(true);
    // }
    // });
  },
  methods: {
    getMessage(value) {
      if (!value || !value.length) return;
      let count = 0;
      value.forEach((item) => {
        if (!item.payload || !item.payload.text) return;
        const obj = Object.assign({}, JSON.parse(item.payload.text), {
          memberNickname: item.nick,
          memberHeadImg: item.avatar,
          createDate: moment(item.time).format('YYYY-MM-DD HH:mm:ss')
        });
        this.list.push(obj);
        count++;
      });
      this.enableBottomOut ? this.bottomOutHandle() : (this.unreadCount = count);
    },
    isInViewPort(element) {
      const viewWidth = window.innerWidth || document.documentElement.clientWidth;
      const viewHeight = window.innerHeight || document.documentElement.clientHeight;
      const { top, right, bottom, left } = element.getBoundingClientRect();
      return top >= 0 && left >= 0 && right <= viewWidth + 1 && bottom <= viewHeight + 1;
    },
    scrollHandle() {
      this.$nextTick(() => {
        const emptyEl = this.$el.querySelector('#bottom-empty');
        (this.enableBottomOut = this.isInViewPort(emptyEl)) && (this.unreadCount = 0);
      });
    },
    bottomOutHandle() {
      this.$nextTick(() => {
        const emptyEl = this.$el.querySelector('#bottom-empty');

        if (!this.isInViewPort(emptyEl)) {
          emptyEl.scrollIntoView({
            behavior: 'smooth',
            block: 'end'
          });
          this.enableBottomOut = true;
          this.unreadCount = 0;
        }
      });
    },
    viewImage(list, cur) {
      function isRmtEnv() {
        return window.navigator.userAgent.indexOf('Rmt') > -1;
      }
      if (isRmtEnv()) {
        const images = list.map((url) => {
          return {
            sourceUrl: url, //原图路径
            thumbUrl: url //缩略图路径
          };
        });
        rmt.openAlbum({
          currentIndex: images.findIndex((v) => v.sourceUrl === cur), //当前打开第几个图片
          //资源列表
          images
        });
      }
    },
    getlist() {
      this.loading = true;

      this.api.question({
        data: {
          roomId: $$.module.data.room.roomId,
          pageNo: this.pageNo,
          pageSize: 5
        },
        success: (data) => {
          // this.list2 = data.records;
          this.value = data;
          data.records.forEach(async (item) => {
            if (item && item.publishDate) {
              item.publishDate = await this.showTimePipe(item.publishDate);
            }
          });
          if (data.records && data.records.length) {
            this.list = this.list
              .reverse()
              .concat(data.records)
              .reverse();
            // this.list.forEach(async (item) => {
            //   if (item && item.publishDate) {
            //     item.publishDate = await this.showTimePipe(item.publishDate);
            //   }
            // });
            this.pageNo++;
            this.scrollHandle();
            this.first && this.bottomOutHandle();
            this.$nextTick(() => {
              document.getElementById(data.records[0].id).scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            });
          } else {
            this.finished = true;
          }
          this.first = false;
          this.loading = false;
          // for (let i in this.list2) {
          //   this.list2[i].imgUrlList.filter((e) => e);
          // }
        }
      });
    },
    showTimePipe(unix_stamp) {
      if (!unix_stamp) {
        return '';
      }
      unix_stamp = Date.parse(unix_stamp.replace(/-/g, '/'));
      if (!unix_stamp) {
        return '';
      }
      // return new Promise((resolve) => {
      // unix_stamp = Date.parse(unix_stamp);
      // unix_stamp 精确到微秒
      var _today_obj = new Date(),
        _today_date = {
          y: _today_obj.getFullYear(),
          m: _today_obj.getMonth() + 1 < 10 ? '0' + (_today_obj.getMonth() - -1) : _today_obj.getMonth() - -1,
          d: _today_obj.getDate() < 10 ? '0' + _today_obj.getDate() : _today_obj.getDate()
        };

      var _today_stamp = Date.parse(_today_date.y + '/' + _today_date.m + '/' + _today_date.d + ' 00:00:00');

      var stamp = [];
      stamp[0] = _today_stamp + 86400000;
      stamp[1] = _today_stamp;
      stamp[2] = _today_stamp - 86400000;
      stamp[3] = _today_stamp - 172800000;

      stamp[4] = _today_stamp - 518400000; // 7天

      stamp[5] = _today_stamp - 31536000000; // 365天

      var _compare_obj = new Date();
      _compare_obj.setTime(unix_stamp);

      var return_str;

      if (unix_stamp >= stamp[1] && unix_stamp < stamp[0]) {
        return_str = _compare_obj.getHours() + ':' + (_compare_obj.getMinutes() < 10 ? '0' + _compare_obj.getMinutes() : _compare_obj.getMinutes());
      } else if (unix_stamp >= stamp[2] && unix_stamp < stamp[1]) {
        var yesterdayText = '昨天';
        return_str =
          yesterdayText +
          ' ' +
          _compare_obj.getHours() +
          ':' +
          (_compare_obj.getMinutes() < 10 ? '0' + _compare_obj.getMinutes() : _compare_obj.getMinutes());
        console.log(return_str, 'return_str昨');
      } else if (unix_stamp >= stamp[3] && unix_stamp < stamp[2]) {
        var theDayBeforeYesterdayText = '前天';
        return_str =
          theDayBeforeYesterdayText +
          ' ' +
          _compare_obj.getHours() +
          ':' +
          (_compare_obj.getMinutes() < 10 ? '0' + _compare_obj.getMinutes() : _compare_obj.getMinutes());
      } else if (unix_stamp >= stamp[4] && unix_stamp < stamp[3]) {
        // 7天内
        var daynames = ['天', '一', '二', '三', '四', '五', '六'];
        var dathStr = '星期' + daynames[_compare_obj.getDay()];

        var SundayText = '星期天';
        var MondayText = '星期一';
        var TuesdayText = '星期二';
        var WednesdayText = '星期三';
        var ThursdayText = '星期四';
        var FridayText = '星期五';
        var SaturdayText = '星期六';

        var dathStr2;

        switch (dathStr) {
          case '星期天':
            dathStr2 = SundayText;
            break;
          case '星期一':
            dathStr2 = MondayText;
            break;
          case '星期二':
            dathStr2 = TuesdayText;
            break;
          case '星期三':
            dathStr2 = WednesdayText;
            break;
          case '星期四':
            dathStr2 = ThursdayText;
            break;
          case '星期五':
            dathStr2 = FridayText;
            break;
          case '星期六':
            dathStr2 = SaturdayText;
            break;
          default:
            dathStr2 = dathStr;
            break;
        }

        return_str =
          dathStr2 +
          ' ' +
          _compare_obj.getHours() +
          ':' +
          (_compare_obj.getMinutes() < 10 ? '0' + _compare_obj.getMinutes() : _compare_obj.getMinutes());
      } else if (unix_stamp >= stamp[5] && unix_stamp < stamp[4]) {
        // 365天内
        var monthText = '月';
        var dayText = '日';
        return_str =
          _compare_obj.getMonth() -
          -1 +
          monthText +
          _compare_obj.getDate() +
          dayText +
          ' ' +
          _compare_obj.getHours() +
          ':' +
          (_compare_obj.getMinutes() < 10 ? '0' + _compare_obj.getMinutes() : _compare_obj.getMinutes());
      } else {
        var yearText = '年';
        let monthText = '月';
        let dayText = '日';
        return_str =
          _compare_obj.getFullYear() +
          yearText +
          (_compare_obj.getMonth() - -1) +
          monthText +
          _compare_obj.getDate() +
          dayText +
          ' ' +
          _compare_obj.getHours() +
          ':' +
          (_compare_obj.getMinutes() < 10 ? '0' + _compare_obj.getMinutes() : _compare_obj.getMinutes());
      }
      return return_str;
      // resolve(return_str);
      // });
    },
    view() {
      setTimeout(() => {
        this.getlist();
        console.log(this.list, 'this.list');
      }, 1000);
    },
    onLoad() {
      console.log(11111);
      this.getlist();
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.refreshing = false;
      this.list = [];
      this.pageNo = 1;
      this.getlist();
    },
    onLoadMore() {
      this.view();
    }
  }
};
</script>
<style lang="less" scoped></style>
